const Course_Proxy = "https://brfenergi.se/iprog/group/747/"
const API_Server = "https://spoonacular-recipe-food-nutrition-v1.p.rapidapi.com"

export const PROXY_URL = Course_Proxy + API_Server
export const PROXY_KEY = "3d2a031b4cmsh5cd4e7b939ada54p19f679jsn9a775627d767"